import React from "react";
import numeral from "numeral";
import { differenceInDays } from "date-fns";

export default class BookingRateRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.rate) {
      return (
        <div className="text-center" style={{ padding: "30px" }}>
          {I18n.t("no_rates_available")}
        </div>
      );
    }

    var average_subtotal = this.props.rate.average_amount;
    var products = this.renderProducts(this.props.rate);
    return (
      <div className="BookingRateRow">
        <div className="row">
          <div className="col-sm-8 RateDescription">
            <div style={{ fontWeight: "bold" }}>
              {this.props.rate.name} {this.renderDescription()}
            </div>

            {this.props.rate.rate_products &&
            this.props.rate.rate_products.length ? (
              <div>
                <label>{I18n.t("includes")}:</label>
                <ul>{products}</ul>
              </div>
            ) : null}
            {this.props.rate.short_description ? (
              <div>{this.props.rate.short_description}</div>
            ) : null}
          </div>
          <div className="col-sm-4 RateAmount">
            <div>
              <strong>
                {this.props.currency.symbol}
                {numeral(
                  (average_subtotal * this.props.currency.exchange_rate) / 100
                ).format(this.props.number_format)}
                {I18n.t("slash_night")}
              </strong>
            </div>
            <div className="with-taxes-and-fees">
              {I18n.t("excludes_taxes_and_fees")}
            </div>
            <div style={{ paddingTop: "3px" }}>
              <button
                type="button"
                className="book-btn add-room-to-cart"
                style={{ float: "right" }}
                onClick={this.props.onAddReservationSegment.bind(
                  null,
                  this.props.room_type,
                  this.props.rate,
                  this.props.start_date,
                  this.props.end_date,
                  this.props.guests
                )}
              >
                {I18n.t("select")}
              </button>
            </div>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-sm-12">
            <button
              type="button"
              className="book-btn add-room-to-cart"
              style={{ float: "right" }}
              onClick={this.props.onAddReservationSegment.bind(
                null,
                this.props.room_type,
                this.props.rate,
                this.props.start_date,
                this.props.end_date,
                this.props.guests
              )}
            >
              {I18n.t("select")}
            </button>
          </div>
        </div> */}
      </div>
    );
  }

  renderDescription() {
    if (this.props.rate.long_description) {
      return (
        <span
          className="help ss-help"
          title={this.props.rate.long_description}
        ></span>
      );
    } else if (this.props.rate.short_description) {
      return (
        <span
          className="help ss-help"
          title={this.props.rate.short_description}
        ></span>
      );
    }
  }

  calculateAverageSubtotal() {
    var amt = 0;
    for (var i = 0, ilen = this.props.rate.dates.length; i < ilen; i++) {
      amt = amt + this.props.rate.dates[i].amount;
    }
    return amt / this.props.rate.dates.length;
  }

  calculateAverageTaxes() {
    var amt = 0;
    for (var i = 0, ilen = this.props.rate.dates.length; i < ilen; i++) {
      amt = amt + this.props.rate.dates[i].taxes_and_fees_amount;
    }
    return amt / this.props.rate.dates.length;
  }

  renderProducts(rate) {
    var products = [];
    if (rate.rate_products && rate.rate_products.length) {
      rate.rate_products.map((rate_product) => {
        products.push(
          <li key={rate_product.name}>
            {rate_product.quantity} {rate_product.name}
          </li>
        );
      });
    }
    return products;
  }

  calculateDailyGuestFees(rate) {
    var total = 0;

    if (rate.rate_guest_types && rate.rate_guest_types.length) {
      for (var j = 0, jlen = rate.rate_guest_types.length; j < jlen; j++) {
        var rate_guest_type = rate.rate_guest_types[j];
        for (var k = 0, klen = this.props.guests.length; k < klen; k++) {
          var guest_type = this.props.guests[k];
          if (guest_type.id == rate_guest_type.guest_type_id) {
            if (guest_type.number_of_guests > rate_guest_type.guests_included) {
              if (rate_guest_type.frequency == "recurring") {
                total =
                  total +
                  (guest_type.number_of_guests -
                    rate_guest_type.guests_included) *
                    rate_guest_type.additional_guest_price_amount;
              } else if (rate_guest_type.frequency == "one_time") {
                var duration = differenceInDays(
                  this.props.end_date,
                  this.props.start_date
                );
                var total_amount =
                  (guest_type.number_of_guests -
                    rate_guest_type.guests_included) *
                  rate_guest_type.additional_guest_price_amount;
                total = total + total_amount / duration;
              }
            }
          }
        }
      }
    }

    return total;
  }
}
